import { Avatar, Grid, Typography } from '@mui/material';
import { lighten, useTheme } from '@mui/material/styles';
import { capitalize, first } from 'lodash';
import PropTypes from 'prop-types';
import stc from 'string-to-color';

const PatientNameBanner = ({ patientName }) => {
  const theme = useTheme();

  const getInitialsFromName = (name) => {
    if (!name) return '';
    const nameParts = name.split(',').map((part) => part.trim());
    if (nameParts.length >= 2) {
      const lastName = nameParts[0];
      const firstName = nameParts[1];
      return `${capitalize(first(firstName))}${capitalize(first(lastName))}`;
    }
    const parts = name.split(' ').filter(Boolean);
    if (parts.length >= 2) {
      return `${capitalize(first(parts[0]))}${capitalize(first(parts[parts.length - 1]))}`;
    }
    return capitalize(first(name));
  };

  const avatarBgColor = stc(patientName);

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: 'flex',
        bgcolor: lighten(theme.palette.primary.light, 0.8),
        py: 1.5,
        borderRadius: '4px',
      }}
    >
      <Grid item sx={{ ml: 2 }}>
        <Avatar
          sx={{
            bgcolor: avatarBgColor,
            color: theme.palette.getContrastText(avatarBgColor),
            width: theme.spacing(6),
            height: theme.spacing(6),
            fontSize: '1.5em',
            letterSpacing: '0.1rem',
            m: 'auto',
          }}
          alt={patientName}
        >
          {getInitialsFromName(patientName)}
        </Avatar>
      </Grid>

      <Grid item sx={{ ml: 3 }} justifyItems='center' alignContent='center'>
        <Typography variant='subtitle1' fontWeight='500' sx={{ fontSize: '1rem', lineHeight: 1.5 }}>
          {patientName}
        </Typography>
        <Typography variant='caption' color='text.secondary' sx={{ fontSize: '0.75rem' }}>
          Patient
        </Typography>
      </Grid>
    </Grid>
  );
};

PatientNameBanner.propTypes = {
  patientName: PropTypes.string.isRequired,
};

export default PatientNameBanner;
